export const fadeIn = (el, display = 'block') => {
    const element = typeof el === 'string' ? document.querySelector(el) : el;
    if (!(element instanceof HTMLElement))
        return;
    element.style.display = display;
    let opacity = 0;
    const tick = () => {
        opacity = Math.min(opacity + 0.1, 1);
        element.style.opacity = String(opacity);
        if (opacity < 1)
            requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
};
export const fadeOut = (el) => {
    const element = typeof el === 'string' ? document.querySelector(el) : el;
    if (!(element instanceof HTMLElement))
        return Promise.resolve();
    return new Promise((resolve) => {
        let opacity = 1;
        const tick = () => {
            opacity = Math.max(opacity - 0.1, 0);
            element.style.opacity = String(opacity);
            if (opacity > 0) {
                requestAnimationFrame(tick);
            }
            else {
                element.style.display = 'none';
                resolve();
            }
        };
        requestAnimationFrame(tick);
    });
};
export const observeVisibility = (selector, className = 'visible', threshold = 0.3, removeOnHide = false, rootMargin = '0px', callback) => {
    const items = document.querySelectorAll(selector);
    if (!items.length)
        return;
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add(className);
                callback?.(entry.target);
                if (!removeOnHide)
                    obs.unobserve(entry.target);
            }
            else if (removeOnHide) {
                entry.target.classList.remove(className);
            }
        });
    }, { threshold, rootMargin });
    items.forEach((item) => observer.observe(item));
};
export const initAppHeight = () => {
    const doc = document.documentElement;
    const header = document.querySelector('.js-site-header');
    window.addEventListener('resize', () => {
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        if (header) {
            doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
        }
    });
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    if (header) {
        doc.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
};
